import { render, staticRenderFns } from "./ConfiguracoesFabricantes.vue?vue&type=template&id=73fb531e&scoped=true&"
import script from "./ConfiguracoesFabricantes.vue?vue&type=script&lang=js&"
export * from "./ConfiguracoesFabricantes.vue?vue&type=script&lang=js&"
import style0 from "./ConfiguracoesFabricantes.vue?vue&type=style&index=0&id=73fb531e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73fb531e",
  null
  
)

export default component.exports